import { Autocomplete, TextField } from '@mui/material';
import { DashboardViewMode } from 'app/agriculture/routes/Devices/DeviceDetails/context/DashboardViewConfig';

interface Props {
    chartViewMode: DashboardViewMode;
    setChartViewMode: (chartViewMode: DashboardViewMode) => void;
}
export function TimePeriodSelector({ chartViewMode, setChartViewMode: setChartViewMode }: Props) {
    const options = ['Day', 'Week', 'Month', 'Year'] as const satisfies DashboardViewMode[];

    return (
        <Autocomplete
            disableClearable
            id="ag-weather-station-autocomplete"
            options={options}
            autoComplete
            value={chartViewMode}
            noOptionsText="No Options"
            onChange={(_, newValue) => {
                setChartViewMode(newValue);
            }}
            renderInput={(params) => <TextField {...params} label="Time Period" fullWidth />}
        />
    );
}
